import { toString, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { FeeGeneratedDTO, FeeGeneratedUpdateDTO, FeeGeneratedUpdateDTO$reflection, FeeGeneratedDTO$reflection, ContractTypePriceRguStratumDTO, ContractTypePriceRguStratumDTO$reflection, ContractTypePriceDTO, ContractTypePriceDTO$reflection } from "./Model.js";
import { class_type, int32_type, record_type, lambda_type, unit_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { Flatpickr_OnChangeOption, loadEffect, LoadState$2, getTranslationFrom } from "../../Global.js";
import * as react from "react";
import { compare, partialApply, uncurry, int32ToString, int16ToString } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { stackClasses, parseInt$, strToOpt, optToStr, DateTimeExtensions_toDate, Locale$reflection, logei, $007CByte$007C_$007C, $007CDecimal$007C_$007C, $007CInt$007C_$007C, $007CInt16$007C_$007C, decimalToTwoDecimals } from "../../Utils.js";
import { render as render_1 } from "../../Components/Modals/Standard.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import { singleton, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_2 } from "../../Components/StatefulFormFields/Text.js";
import { Browser_Types_Event__Event_get_Checked, Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { isOnlyNumberWithPossibleDecimals, isNotNullOrWhitespace, InputType, lengthLTE, isOnlyNumbers } from "../../Validation/Common.js";
import { Result_Bind } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { error } from "../../Components/Message/Message.js";
import { FeeWholesale_create, FeeWholesale_update, FeeWholesale_read, ContractTypePriceRguStratum_delete, ContractTypePriceRguStratum_create, ContractTypePriceRguStratum_update, ContractTypePriceRguStratum_read, ContractTypePrice_delete, ContractTypePrice_create, ContractTypePrice_update, ContractTypePrice_read } from "./Api.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { renderModal } from "../../Components/Modals/Choice/Choice.js";
import { dotsLoading } from "../../ViewUtils.js";
import { filter, singleton as singleton_2, tryFind, ofArray, map } from "../../fable_modules/fable-library.3.7.20/List.js";
import { parse } from "../../fable_modules/fable-library.3.7.20/Int32.js";
import { ButtonProps, defaultProps, ButtonKind, wrappedButton } from "../../Components/Button/Button.js";
import { fromParts } from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import { renderDotMenuAreaTable } from "../../Components/Table/Table.js";
import { split, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { DateOptionsSimple, DateOptionsSimple_get_getDefault, inputDateSimple } from "../../Components/FormFields/FormFields.js";
import { fromDateTime, toDateTime } from "../../fable_modules/fable-library.3.7.20/DateOnly.js";
import { create } from "../../fable_modules/fable-library.3.7.20/TimeOnly.js";
import { DateModule_today, DateFormat_get_yyyy$002DMM$002Ddd, DateModule_toStr, DateModule_ofDateTime } from "../../Svea.Dry/Time.js";
import { defaultArg, map as map_1 } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { SwitchProps, SwitchProps_get_GetDefault, render as render_3 } from "../../Components/Switch/Switch.js";
import { now } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import "../../../src/Containers/WholesaleRGU/View.scss";


class ContractTypePriceModalProps extends Record {
    constructor(DTO, SaveFn, CloseModalFn) {
        super();
        this.DTO = DTO;
        this.SaveFn = SaveFn;
        this.CloseModalFn = CloseModalFn;
    }
}

function ContractTypePriceModalProps$reflection() {
    return record_type("Containers.WholesaleRGU.View.ContractTypePriceModalProps", [], ContractTypePriceModalProps, () => [["DTO", ContractTypePriceDTO$reflection()], ["SaveFn", lambda_type(ContractTypePriceDTO$reflection(), unit_type)], ["CloseModalFn", lambda_type(unit_type, unit_type)]]);
}

const renderContractTypePriceModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_7;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const contractTypePriceIdState = react.useState(int16ToString(props.DTO.ContractTypePriceId));
    const contractContractNrState = react.useState(int32ToString(props.DTO.ContractContractNr));
    const nameState = react.useState(props.DTO.Name);
    const rguMinimumCostExclVatState = react.useState(decimalToTwoDecimals(props.DTO.RGUMinimumCostExclVat));
    const rguaCostExclVatState = react.useState(decimalToTwoDecimals(props.DTO.RGUACostExclVat));
    const vatPercentState = react.useState(props.DTO.VatPercent.toString());
    const accountNoState = react.useState(int32ToString(props.DTO.AccountNo));
    const errorMessageState = react.useState(void 0);
    return render_1(true, new ModalSize(1), "ContractTypePrice", (children_7 = toList(delay(() => {
        let children, inputRecord, inputRecord_1;
        return append(singleton((children = [render_2()((inputRecord = TextProps$1_GetDefault(), new TextProps$1(contractTypePriceIdState[0], inputRecord.Type, inputRecord.Classes, (e) => {
            contractTypePriceIdState[1](Browser_Types_Event__Event_get_Value(e));
        }, inputRecord.Disabled, "ContractTypePriceId", "rgu-contract-type-price-id", (str) => isOnlyNumbers(getTranslation, str), inputRecord.DynamicWidth, inputRecord.HTMLProps, inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name))), render_2()((inputRecord_1 = TextProps$1_GetDefault(), new TextProps$1(contractContractNrState[0], inputRecord_1.Type, inputRecord_1.Classes, (e_1) => {
            contractContractNrState[1](Browser_Types_Event__Event_get_Value(e_1));
        }, inputRecord_1.Disabled, "ContractContractNr", "rgu-contract-contract-nr", (str_1) => isOnlyNumbers(getTranslation, str_1), inputRecord_1.DynamicWidth, inputRecord_1.HTMLProps, inputRecord_1.OnBlur, inputRecord_1.OnFocus, inputRecord_1.AutoComplete, inputRecord_1.Name)))], react.createElement("div", {
            className: "rgu-modal__container",
        }, ...children))), delay(() => {
            let inputRecord_2;
            return append(singleton(render_2()((inputRecord_2 = TextProps$1_GetDefault(), new TextProps$1(nameState[0], inputRecord_2.Type, inputRecord_2.Classes, (e_2) => {
                nameState[1](Browser_Types_Event__Event_get_Value(e_2));
            }, inputRecord_2.Disabled, "Name", "rgu-name", (arg) => Result_Bind((str_3) => lengthLTE(getTranslation, 50, new InputType(2), str_3), isNotNullOrWhitespace(getTranslation, arg)), inputRecord_2.DynamicWidth, inputRecord_2.HTMLProps, inputRecord_2.OnBlur, inputRecord_2.OnFocus, inputRecord_2.AutoComplete, inputRecord_2.Name)))), delay(() => {
                let children_2, inputRecord_3, inputRecord_4;
                return append(singleton((children_2 = [render_2()((inputRecord_3 = TextProps$1_GetDefault(), new TextProps$1(rguMinimumCostExclVatState[0], inputRecord_3.Type, inputRecord_3.Classes, (e_3) => {
                    rguMinimumCostExclVatState[1](Browser_Types_Event__Event_get_Value(e_3));
                }, inputRecord_3.Disabled, "RGUMinimumCostExclVat", "rgu-minimum-cost-excl-vat", (str_4) => isOnlyNumberWithPossibleDecimals(getTranslation, str_4), inputRecord_3.DynamicWidth, inputRecord_3.HTMLProps, inputRecord_3.OnBlur, inputRecord_3.OnFocus, inputRecord_3.AutoComplete, inputRecord_3.Name))), render_2()((inputRecord_4 = TextProps$1_GetDefault(), new TextProps$1(rguaCostExclVatState[0], inputRecord_4.Type, inputRecord_4.Classes, (e_4) => {
                    rguaCostExclVatState[1](Browser_Types_Event__Event_get_Value(e_4));
                }, inputRecord_4.Disabled, "RGUACostExclVat", "rgua-cost-excl-vat", (str_5) => isOnlyNumberWithPossibleDecimals(getTranslation, str_5), inputRecord_4.DynamicWidth, inputRecord_4.HTMLProps, inputRecord_4.OnBlur, inputRecord_4.OnFocus, inputRecord_4.AutoComplete, inputRecord_4.Name)))], react.createElement("div", {
                    className: "rgu-modal__container",
                }, ...children_2))), delay(() => {
                    let children_4, inputRecord_5, inputRecord_6;
                    return append(singleton((children_4 = [render_2()((inputRecord_5 = TextProps$1_GetDefault(), new TextProps$1(vatPercentState[0], inputRecord_5.Type, inputRecord_5.Classes, (e_5) => {
                        vatPercentState[1](Browser_Types_Event__Event_get_Value(e_5));
                    }, inputRecord_5.Disabled, "VatPercent", "rgua-vat-percent", (str_6) => isOnlyNumbers(getTranslation, str_6), inputRecord_5.DynamicWidth, inputRecord_5.HTMLProps, inputRecord_5.OnBlur, inputRecord_5.OnFocus, inputRecord_5.AutoComplete, inputRecord_5.Name))), render_2()((inputRecord_6 = TextProps$1_GetDefault(), new TextProps$1(accountNoState[0], inputRecord_6.Type, inputRecord_6.Classes, (e_6) => {
                        accountNoState[1](Browser_Types_Event__Event_get_Value(e_6));
                    }, inputRecord_6.Disabled, "AccountNo", "rgua-account-no", (str_7) => isOnlyNumbers(getTranslation, str_7), inputRecord_6.DynamicWidth, inputRecord_6.HTMLProps, inputRecord_6.OnBlur, inputRecord_6.OnFocus, inputRecord_6.AutoComplete, inputRecord_6.Name)))], react.createElement("div", {
                        className: "rgu-modal__container",
                    }, ...children_4))), delay(() => {
                        const matchValue_1 = errorMessageState[0];
                        if (matchValue_1 != null) {
                            const msg = matchValue_1;
                            return singleton(error(msg.split("")));
                        }
                        else {
                            return singleton(react.createElement(react.Fragment, {}));
                        }
                    }));
                }));
            }));
        }));
    })), react.createElement("div", {
        className: "rgu-modal",
    }, ...children_7)), getTranslation("Common.Cancel"), getTranslation("Common.Save"), (_arg) => {
        props.CloseModalFn();
    }, (_arg_1) => {
        const matchValue = [contractTypePriceIdState[0], contractContractNrState[0], rguMinimumCostExclVatState[0], rguaCostExclVatState[0], vatPercentState[0], accountNoState[0]];
        let pattern_matching_result, accountNo, contractContractNr, contractTypePriceId, rguMinCost, rguaCost, vatPercent;
        const activePatternResult = $007CInt16$007C_$007C(matchValue[0]);
        if (activePatternResult != null) {
            const activePatternResult_1 = $007CInt$007C_$007C(matchValue[1]);
            if (activePatternResult_1 != null) {
                const activePatternResult_2 = $007CDecimal$007C_$007C(matchValue[2]);
                if (activePatternResult_2 != null) {
                    const activePatternResult_3 = $007CDecimal$007C_$007C(matchValue[3]);
                    if (activePatternResult_3 != null) {
                        const activePatternResult_4 = $007CByte$007C_$007C(matchValue[4]);
                        if (activePatternResult_4 != null) {
                            const activePatternResult_5 = $007CInt$007C_$007C(matchValue[5]);
                            if (activePatternResult_5 != null) {
                                pattern_matching_result = 0;
                                accountNo = activePatternResult_5;
                                contractContractNr = activePatternResult_1;
                                contractTypePriceId = activePatternResult;
                                rguMinCost = activePatternResult_2;
                                rguaCost = activePatternResult_3;
                                vatPercent = activePatternResult_4;
                            }
                            else {
                                pattern_matching_result = 1;
                            }
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                props.SaveFn(new ContractTypePriceDTO(nameState[0], contractTypePriceId, contractContractNr, rguMinCost, rguaCost, vatPercent, accountNo));
                break;
            }
            case 1: {
                errorMessageState[1]("Tried to save, but unable to due to data in form not parsing correctly.");
                break;
            }
        }
        props.CloseModalFn();
    });
}, void 0, uncurry(2, void 0), void 0, "renderContractTypePriceModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\WholesaleRGU\\View.fs", 160);

class ContractTypePriceSectionProps extends Record {
    constructor(ClientNr, InvoiceeNr) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.InvoiceeNr = InvoiceeNr;
    }
}

function ContractTypePriceSectionProps$reflection() {
    return record_type("Containers.WholesaleRGU.View.ContractTypePriceSectionProps", [], ContractTypePriceSectionProps, () => [["ClientNr", int32_type], ["InvoiceeNr", class_type("System.Int64")]]);
}

const renderContractTypePriceSection = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_2, children_8;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const contractTypePriceLoadState = react.useState(new LoadState$2(0));
    const editModalState = react.useState(void 0);
    const deleteModalState = react.useState(void 0);
    const errorMessageState = react.useState(void 0);
    const loadContractTypePrice = () => {
        loadEffect(() => ContractTypePrice_read(props.ClientNr, props.InvoiceeNr), (arg) => {
            contractTypePriceLoadState[1](arg);
        });
    };
    react.useEffect(loadContractTypePrice, [props.ClientNr, props.InvoiceeNr]);
    const saveContractTypePrice = (isUpdate, contractTypePriceId, dto) => {
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(isUpdate ? ContractTypePrice_update(props.ClientNr, props.InvoiceeNr, contractTypePriceId, dto) : ContractTypePrice_create(props.ClientNr, props.InvoiceeNr, dto), (_arg) => {
            const result = _arg;
            return singleton_1.Combine((result.tag === 1) ? ((errorMessageState[1](result.fields[0]), singleton_1.Zero())) : ((singleton_1.Zero())), singleton_1.Delay(() => {
                loadContractTypePrice();
                return singleton_1.Zero();
            }));
        })));
    };
    let editModalHtml;
    const matchValue = editModalState[0];
    editModalHtml = ((matchValue != null) ? renderContractTypePriceModal(matchValue) : react.createElement(react.Fragment, {}));
    let deleteModalHtml;
    const matchValue_1 = deleteModalState[0];
    if (matchValue_1 != null) {
        const dto_1 = matchValue_1;
        deleteModalHtml = renderModal(getTranslation("Common.Remove") + " ContractTypePrice", (children_2 = [getTranslation("Common.AreYouSure")], react.createElement("div", {}, ...children_2)), getTranslation("Common.Cancel"), getTranslation("Common.Remove"), (_arg_2) => {
            deleteModalState[1](void 0);
        }, (_arg_3) => {
            startImmediate(singleton_1.Delay(() => singleton_1.Bind(ContractTypePrice_delete(props.ClientNr, props.InvoiceeNr, dto_1.ContractTypePriceId), (_arg_1) => {
                const result_1 = _arg_1;
                return singleton_1.Combine((result_1.tag === 1) ? ((errorMessageState[1](result_1.fields[0]), singleton_1.Zero())) : ((singleton_1.Zero())), singleton_1.Delay(() => {
                    loadContractTypePrice();
                    return singleton_1.Zero();
                }));
            })));
            deleteModalState[1](void 0);
        });
    }
    else {
        deleteModalHtml = react.createElement(react.Fragment, {});
    }
    const matchValue_2 = contractTypePriceLoadState[0];
    switch (matchValue_2.tag) {
        case 1: {
            return dotsLoading;
        }
        case 3: {
            return error(matchValue_2.fields[0].split(""));
        }
        case 2: {
            const contractTypePrices = matchValue_2.fields[0];
            const rows = map((ctp) => {
                const renderCell = toString;
                return [ofArray([renderCell(ctp.ContractTypePriceId), renderCell(ctp.ContractContractNr), renderCell(ctp.Name), decimalToTwoDecimals(ctp.RGUMinimumCostExclVat), decimalToTwoDecimals(ctp.RGUACostExclVat), renderCell(ctp.VatPercent), renderCell(ctp.AccountNo)]), int16ToString(ctp.ContractTypePriceId)];
            }, contractTypePrices);
            const getDotMenuAction = (fn, rowId) => {
                const matchValue_3 = tryFind((ctp_1) => (ctp_1.ContractTypePriceId === parse(rowId, 511, false, 16)), contractTypePrices);
                if (matchValue_3 != null) {
                    fn(matchValue_3);
                }
                else {
                    logei("Cannot find ContractTypePrice based on RowId: " + rowId);
                }
            };
            const dotMenu = ofArray([[getTranslation("Common.Edit"), partialApply(1, getDotMenuAction, [(ctp_3) => {
                const modalProps_1 = new ContractTypePriceModalProps(ctp_3, (dto_2) => {
                    saveContractTypePrice(true, ctp_3.ContractTypePriceId, dto_2);
                }, () => {
                    editModalState[1](void 0);
                });
                editModalState[1](modalProps_1);
            }])], [getTranslation("Common.Remove"), partialApply(1, getDotMenuAction, [(ctp_4) => {
                deleteModalState[1](ctp_4);
            }])]]);
            let errorMessageHtml;
            const matchValue_4 = errorMessageState[0];
            if (matchValue_4 != null) {
                const msg_3 = matchValue_4;
                errorMessageHtml = error(msg_3.split(""));
            }
            else {
                errorMessageHtml = react.createElement(react.Fragment, {});
            }
            const createContractTypePriceButtonHtml = wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("Common.CreateNew"), defaultProps.Content, (_arg_4) => {
                const arg_9 = new ContractTypePriceModalProps(new ContractTypePriceDTO("", 0, 0, fromParts(0, 0, 0, false, 1), fromParts(0, 0, 0, false, 1), 0, 0), (dto_4) => {
                    saveContractTypePrice(false, dto_4.ContractTypePriceId, dto_4);
                }, () => {
                    editModalState[1](void 0);
                });
                editModalState[1](arg_9);
            }, defaultProps.Disabled, "create-contract-type-price-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon));
            const children_10 = [react.createElement("h3", {}, "ContractTypePrice"), errorMessageHtml, createContractTypePriceButtonHtml, (children_8 = [renderDotMenuAreaTable(ofArray(["ContractTypePriceId", "ContractContractNr", "Name", "RGUMinimumCostExclVat", "RGUACostExclVat", "VatPercent", "AccountNo"]), rows, (_arg_5) => dotMenu, void 0, void 0, (value) => {
            })], react.createElement("div", {
                className: "fit-content",
            }, ...children_8)), editModalHtml, deleteModalHtml];
            return react.createElement("div", {
                id: "contract-type-price-section",
                className: "simple-container",
            }, ...children_10);
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}, "ContractTypePriceSection", uncurry(2, void 0), void 0, "renderContractTypePriceSection", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\WholesaleRGU\\View.fs", 324);

export class ContractTypePriceRguStratumModalProps extends Record {
    constructor(DTO, SaveFn, CloseModalFn) {
        super();
        this.DTO = DTO;
        this.SaveFn = SaveFn;
        this.CloseModalFn = CloseModalFn;
    }
}

export function ContractTypePriceRguStratumModalProps$reflection() {
    return record_type("Containers.WholesaleRGU.View.ContractTypePriceRguStratumModalProps", [], ContractTypePriceRguStratumModalProps, () => [["DTO", ContractTypePriceRguStratumDTO$reflection()], ["SaveFn", lambda_type(ContractTypePriceRguStratumDTO$reflection(), unit_type)], ["CloseModalFn", lambda_type(unit_type, unit_type)]]);
}

export const renderContractTypePriceRguStratumModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_3;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const contractTypePriceIdState = react.useState(int16ToString(props.DTO.ContractTypePriceId));
    const effectiveOverNumContractsState = react.useState(int32ToString(props.DTO.EffectiveOverNumContracts));
    const rguaCostExclVatState = react.useState(decimalToTwoDecimals(props.DTO.RGUACostExclVat));
    const errorMessageState = react.useState(void 0);
    return render_1(true, new ModalSize(1), "ContractTypePriceRguStratum", (children_3 = toList(delay(() => {
        let children, inputRecord, inputRecord_1, inputRecord_2;
        return append(singleton((children = [render_2()((inputRecord = TextProps$1_GetDefault(), new TextProps$1(contractTypePriceIdState[0], inputRecord.Type, inputRecord.Classes, (e) => {
            contractTypePriceIdState[1](Browser_Types_Event__Event_get_Value(e));
        }, inputRecord.Disabled, "ContractTypePriceId", "rgu-contract-type-price-id", (str) => isOnlyNumbers(getTranslation, str), inputRecord.DynamicWidth, inputRecord.HTMLProps, inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name))), render_2()((inputRecord_1 = TextProps$1_GetDefault(), new TextProps$1(effectiveOverNumContractsState[0], inputRecord_1.Type, inputRecord_1.Classes, (e_1) => {
            effectiveOverNumContractsState[1](Browser_Types_Event__Event_get_Value(e_1));
        }, inputRecord_1.Disabled, "EffectiveOverNumContracts", "rgu-effective-over-num-contracts", (str_1) => isOnlyNumbers(getTranslation, str_1), inputRecord_1.DynamicWidth, inputRecord_1.HTMLProps, inputRecord_1.OnBlur, inputRecord_1.OnFocus, inputRecord_1.AutoComplete, inputRecord_1.Name))), render_2()((inputRecord_2 = TextProps$1_GetDefault(), new TextProps$1(rguaCostExclVatState[0], inputRecord_2.Type, inputRecord_2.Classes, (e_2) => {
            rguaCostExclVatState[1](Browser_Types_Event__Event_get_Value(e_2));
        }, inputRecord_2.Disabled, "RGUACostExclVat", "rgua-cost-excl-vat", (str_2) => isOnlyNumberWithPossibleDecimals(getTranslation, str_2), inputRecord_2.DynamicWidth, inputRecord_2.HTMLProps, inputRecord_2.OnBlur, inputRecord_2.OnFocus, inputRecord_2.AutoComplete, inputRecord_2.Name)))], react.createElement("div", {
            className: "rgu-modal__container",
        }, ...children))), delay(() => {
            const matchValue_1 = errorMessageState[0];
            if (matchValue_1 != null) {
                const msg = matchValue_1;
                return singleton(error(msg.split("")));
            }
            else {
                return singleton(react.createElement(react.Fragment, {}));
            }
        }));
    })), react.createElement("div", {
        className: "rgu-modal",
    }, ...children_3)), getTranslation("Common.Cancel"), getTranslation("Common.Save"), (_arg) => {
        props.CloseModalFn();
    }, (_arg_1) => {
        const matchValue = [contractTypePriceIdState[0], effectiveOverNumContractsState[0], rguaCostExclVatState[0]];
        let pattern_matching_result, contractTypePriceId, effectiveOverNumContracts, rguaCost;
        const activePatternResult = $007CInt16$007C_$007C(matchValue[0]);
        if (activePatternResult != null) {
            const activePatternResult_1 = $007CInt$007C_$007C(matchValue[1]);
            if (activePatternResult_1 != null) {
                const activePatternResult_2 = $007CDecimal$007C_$007C(matchValue[2]);
                if (activePatternResult_2 != null) {
                    pattern_matching_result = 0;
                    contractTypePriceId = activePatternResult;
                    effectiveOverNumContracts = activePatternResult_1;
                    rguaCost = activePatternResult_2;
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                props.SaveFn(new ContractTypePriceRguStratumDTO(contractTypePriceId, effectiveOverNumContracts, rguaCost));
                break;
            }
            case 1: {
                errorMessageState[1]("Tried to save, but unable to due to data in form not parsing correctly.");
                break;
            }
        }
        props.CloseModalFn();
    });
}, "ContractTypePriceRguStratumModal", uncurry(2, void 0), void 0, "renderContractTypePriceRguStratumModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\WholesaleRGU\\View.fs", 414);

class ContractTypePriceRguStratumSectionProps extends Record {
    constructor(ClientNr, InvoiceeNr) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.InvoiceeNr = InvoiceeNr;
    }
}

function ContractTypePriceRguStratumSectionProps$reflection() {
    return record_type("Containers.WholesaleRGU.View.ContractTypePriceRguStratumSectionProps", [], ContractTypePriceRguStratumSectionProps, () => [["ClientNr", int32_type], ["InvoiceeNr", class_type("System.Int64")]]);
}

const renderContractTypePriceRguStratumSection = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_2, children_8;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const contractTypePriceRguStratumLoadState = react.useState(new LoadState$2(0));
    const editModalState = react.useState(void 0);
    const deleteModalState = react.useState(void 0);
    const errorMessageState = react.useState(void 0);
    const loadContractTypePriceRguStratum = () => {
        loadEffect(() => ContractTypePriceRguStratum_read(props.ClientNr, props.InvoiceeNr), (arg) => {
            contractTypePriceRguStratumLoadState[1](arg);
        });
    };
    react.useEffect(loadContractTypePriceRguStratum, [props.ClientNr, props.InvoiceeNr]);
    const saveContractTypePriceRguStratum = (isUpdate, contractTypePriceId, effectiveOverNumContracts, dto) => {
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(isUpdate ? ContractTypePriceRguStratum_update(props.ClientNr, props.InvoiceeNr, contractTypePriceId, effectiveOverNumContracts, dto) : ContractTypePriceRguStratum_create(props.ClientNr, props.InvoiceeNr, dto), (_arg) => {
            const result = _arg;
            return singleton_1.Combine((result.tag === 1) ? ((errorMessageState[1](result.fields[0]), singleton_1.Zero())) : ((singleton_1.Zero())), singleton_1.Delay(() => {
                loadContractTypePriceRguStratum();
                return singleton_1.Zero();
            }));
        })));
    };
    let editModalHtml;
    const matchValue = editModalState[0];
    editModalHtml = ((matchValue != null) ? renderContractTypePriceRguStratumModal(matchValue) : react.createElement(react.Fragment, {}));
    let deleteModalHtml;
    const matchValue_1 = deleteModalState[0];
    if (matchValue_1 != null) {
        const dto_1 = matchValue_1;
        deleteModalHtml = renderModal(getTranslation("Common.Remove") + " ContractTypePriceRguStratum", (children_2 = [getTranslation("Common.AreYouSure")], react.createElement("div", {}, ...children_2)), getTranslation("Common.Cancel"), getTranslation("Common.Remove"), (_arg_2) => {
            deleteModalState[1](void 0);
        }, (_arg_3) => {
            startImmediate(singleton_1.Delay(() => singleton_1.Bind(ContractTypePriceRguStratum_delete(props.ClientNr, props.InvoiceeNr, dto_1.ContractTypePriceId, dto_1.EffectiveOverNumContracts), (_arg_1) => {
                const result_1 = _arg_1;
                return singleton_1.Combine((result_1.tag === 1) ? ((errorMessageState[1](result_1.fields[0]), singleton_1.Zero())) : ((singleton_1.Zero())), singleton_1.Delay(() => {
                    loadContractTypePriceRguStratum();
                    return singleton_1.Zero();
                }));
            })));
            deleteModalState[1](void 0);
        });
    }
    else {
        deleteModalHtml = react.createElement(react.Fragment, {});
    }
    const matchValue_2 = contractTypePriceRguStratumLoadState[0];
    switch (matchValue_2.tag) {
        case 1: {
            return dotsLoading;
        }
        case 3: {
            return error(matchValue_2.fields[0].split(""));
        }
        case 2: {
            const contractTypePriceRguStratums = matchValue_2.fields[0];
            const rows = map((ctp) => {
                let arg_4, copyOfStruct_1, arg_3, copyOfStruct;
                const renderCell = toString;
                return [ofArray([renderCell(ctp.ContractTypePriceId), renderCell(ctp.EffectiveOverNumContracts), decimalToTwoDecimals(ctp.RGUACostExclVat)]), (arg_4 = ((copyOfStruct_1 = ctp.EffectiveOverNumContracts, toString(copyOfStruct_1))), (arg_3 = ((copyOfStruct = ctp.ContractTypePriceId, toString(copyOfStruct))), toText(printf("%s-%s"))(arg_3)(arg_4)))];
            }, contractTypePriceRguStratums);
            let dotMenu;
            const getDotMenuAction = (fn, rowId_1) => {
                let patternInput;
                const splitted = split(rowId_1, ["-"], null, 0);
                patternInput = [parse(splitted[0], 511, false, 16), parse(splitted[1], 511, false, 32)];
                const matchValue_3 = tryFind((ctp_1) => {
                    if (ctp_1.ContractTypePriceId === patternInput[0]) {
                        return ctp_1.EffectiveOverNumContracts === patternInput[1];
                    }
                    else {
                        return false;
                    }
                }, contractTypePriceRguStratums);
                if (matchValue_3 != null) {
                    fn(matchValue_3);
                }
                else {
                    logei("Cannot find ContractTypePrice based on RowId: " + rowId_1);
                }
            };
            dotMenu = ofArray([[getTranslation("Common.Edit"), partialApply(1, getDotMenuAction, [(ctp_3) => {
                const modalProps_1 = new ContractTypePriceRguStratumModalProps(ctp_3, (dto_2) => {
                    saveContractTypePriceRguStratum(true, ctp_3.ContractTypePriceId, ctp_3.EffectiveOverNumContracts, dto_2);
                }, () => {
                    editModalState[1](void 0);
                });
                editModalState[1](modalProps_1);
            }])], [getTranslation("Common.Remove"), partialApply(1, getDotMenuAction, [(ctp_4) => {
                deleteModalState[1](ctp_4);
            }])]]);
            let errorMessageHtml;
            const matchValue_4 = errorMessageState[0];
            if (matchValue_4 != null) {
                const msg_3 = matchValue_4;
                errorMessageHtml = error(msg_3.split(""));
            }
            else {
                errorMessageHtml = react.createElement(react.Fragment, {});
            }
            const createContractTypePriceRguStratumButtonHtml = wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("Common.CreateNew"), defaultProps.Content, (_arg_4) => {
                const arg_8 = new ContractTypePriceRguStratumModalProps(new ContractTypePriceRguStratumDTO(0, 0, fromParts(0, 0, 0, false, 1)), (dto_4) => {
                    saveContractTypePriceRguStratum(false, dto_4.ContractTypePriceId, dto_4.EffectiveOverNumContracts, dto_4);
                }, () => {
                    editModalState[1](void 0);
                });
                editModalState[1](arg_8);
            }, defaultProps.Disabled, "create-contract-type-price-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon));
            const children_10 = [react.createElement("h3", {}, "ContractTypePriceRguStratum"), errorMessageHtml, createContractTypePriceRguStratumButtonHtml, (children_8 = [renderDotMenuAreaTable(ofArray(["ContractTypePriceId", "EffectiveOverNumContracts", "RGUACostExclVat"]), rows, (_arg_5) => dotMenu, void 0, void 0, (value) => {
            })], react.createElement("div", {
                className: "fit-content",
            }, ...children_8)), editModalHtml, deleteModalHtml];
            return react.createElement("div", {
                id: "contract-type-price-rgu-stratum-section",
                className: "simple-container",
            }, ...children_10);
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}, "ContractTypePriceRguStratumSection", uncurry(2, void 0), void 0, "renderContractTypePriceRguStratumSection", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\WholesaleRGU\\View.fs", 605);

class FeeWholesaleModalProps extends Record {
    constructor(DTO, SaveFn, CloseModalFn, Locale) {
        super();
        this.DTO = DTO;
        this.SaveFn = SaveFn;
        this.CloseModalFn = CloseModalFn;
        this.Locale = Locale;
    }
}

function FeeWholesaleModalProps$reflection() {
    return record_type("Containers.WholesaleRGU.View.FeeWholesaleModalProps", [], FeeWholesaleModalProps, () => [["DTO", FeeGeneratedDTO$reflection()], ["SaveFn", lambda_type(FeeGeneratedUpdateDTO$reflection(), unit_type)], ["CloseModalFn", lambda_type(unit_type, unit_type)], ["Locale", Locale$reflection()]]);
}

const renderFeeWholesaleModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_1;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const feeIdState = react.useState(props.DTO.FeeId);
    const generatorState = react.useState(props.DTO.Generator);
    const invoiceeNrState = react.useState(props.DTO.InvoiceeNr);
    const contractNrState = react.useState(props.DTO.ContractNr);
    const parametersState = react.useState(props.DTO.Parameters);
    const startDateState = react.useState(props.DTO.StartDate);
    const endDateState = react.useState(props.DTO.EndDate);
    const accountNoState = react.useState(int32ToString(props.DTO.AccountNo));
    const errorMessageState = react.useState(void 0);
    return render_1(true, new ModalSize(1), "FeeWholesale", (children_1 = toList(delay(() => {
        let inputRecord;
        return append(singleton(render_2()((inputRecord = TextProps$1_GetDefault(), new TextProps$1(generatorState[0], inputRecord.Type, inputRecord.Classes, (e) => {
            generatorState[1](Browser_Types_Event__Event_get_Value(e));
        }, inputRecord.Disabled, "Generator", "rgu-generator", inputRecord.ValidationFn, inputRecord.DynamicWidth, inputRecord.HTMLProps, inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name)))), delay(() => {
            let inputRecord_1;
            return append(singleton(render_2()((inputRecord_1 = TextProps$1_GetDefault(), new TextProps$1(parametersState[0], inputRecord_1.Type, inputRecord_1.Classes, (e_1) => {
                parametersState[1](Browser_Types_Event__Event_get_Value(e_1));
            }, inputRecord_1.Disabled, "Parameters", "rgu-parameters", inputRecord_1.ValidationFn, inputRecord_1.DynamicWidth, inputRecord_1.HTMLProps, inputRecord_1.OnBlur, inputRecord_1.OnFocus, inputRecord_1.AutoComplete, inputRecord_1.Name)))), delay(() => {
                let inputRecord_2, copyOfStruct;
                return append(singleton(inputDateSimple((inputRecord_2 = DateOptionsSimple_get_getDefault(), new DateOptionsSimple("rgu-start-date", (copyOfStruct = (startDateState[0]), toDateTime(copyOfStruct, create(0, 0, 0))), (arg_1) => {
                    const arg = DateModule_ofDateTime(arg_1);
                    startDateState[1](arg);
                }, (date) => DateTimeExtensions_toDate(props.Locale.ILocale, date), inputRecord_2.TimeTwentyFour, "StartDate", true, inputRecord_2.Disabled, props.Locale, inputRecord_2.EnableBy, inputRecord_2.OnClearClick, inputRecord_2.ExtraFlatpickrOptions)))), delay(() => {
                    let inputRecord_3;
                    return append(singleton(inputDateSimple((inputRecord_3 = DateOptionsSimple_get_getDefault(), new DateOptionsSimple("rgu-end-date", map_1((d) => toDateTime(d, create(0, 0, 0)), endDateState[0]), inputRecord_3.OnChange, (date_1) => DateTimeExtensions_toDate(props.Locale.ILocale, date_1), inputRecord_3.TimeTwentyFour, "EndDate", true, inputRecord_3.Disabled, props.Locale, inputRecord_3.EnableBy, inputRecord_3.OnClearClick, singleton_2(Flatpickr_OnChangeOption((arg_3) => {
                        const arg_2 = map_1(DateModule_ofDateTime, arg_3);
                        endDateState[1](arg_2);
                    })))))), delay(() => {
                        let inputRecord_4;
                        return append(singleton(render_2()((inputRecord_4 = TextProps$1_GetDefault(), new TextProps$1(optToStr(invoiceeNrState[0]), "number", inputRecord_4.Classes, (e_2) => {
                            const arg_4 = map_1((value) => parse(value, 511, false, 32), strToOpt(Browser_Types_Event__Event_get_Value(e_2)));
                            invoiceeNrState[1](arg_4);
                        }, inputRecord_4.Disabled, "InvoiceeNr", "rgu-invoiceenr", inputRecord_4.ValidationFn, inputRecord_4.DynamicWidth, inputRecord_4.HTMLProps, inputRecord_4.OnBlur, inputRecord_4.OnFocus, inputRecord_4.AutoComplete, inputRecord_4.Name)))), delay(() => {
                            let inputRecord_5;
                            return append(singleton(render_2()((inputRecord_5 = TextProps$1_GetDefault(), new TextProps$1(optToStr(contractNrState[0]), "number", inputRecord_5.Classes, (e_3) => {
                                const arg_5 = map_1((value_1) => parse(value_1, 511, false, 32), strToOpt(Browser_Types_Event__Event_get_Value(e_3)));
                                contractNrState[1](arg_5);
                            }, inputRecord_5.Disabled, "ContractNr", "rgu-contractnr", inputRecord_5.ValidationFn, inputRecord_5.DynamicWidth, inputRecord_5.HTMLProps, inputRecord_5.OnBlur, inputRecord_5.OnFocus, inputRecord_5.AutoComplete, inputRecord_5.Name)))), delay(() => {
                                let inputRecord_6;
                                return append(singleton(render_2()((inputRecord_6 = TextProps$1_GetDefault(), new TextProps$1(accountNoState[0], inputRecord_6.Type, inputRecord_6.Classes, (e_4) => {
                                    accountNoState[1](Browser_Types_Event__Event_get_Value(e_4));
                                }, inputRecord_6.Disabled, "AccountNo", "rgu-accountno", inputRecord_6.ValidationFn, inputRecord_6.DynamicWidth, inputRecord_6.HTMLProps, inputRecord_6.OnBlur, inputRecord_6.OnFocus, inputRecord_6.AutoComplete, inputRecord_6.Name)))), delay(() => {
                                    const matchValue_1 = errorMessageState[0];
                                    if (matchValue_1 != null) {
                                        const msg = matchValue_1;
                                        return singleton(error(msg.split("")));
                                    }
                                    else {
                                        return singleton(react.createElement(react.Fragment, {}));
                                    }
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })), react.createElement("div", {
        className: "rgu-modal",
    }, ...children_1)), getTranslation("Common.Cancel"), getTranslation("Common.Save"), (_arg_4) => {
        props.CloseModalFn();
    }, (_arg_5) => {
        const matchValue = accountNoState[0];
        const activePatternResult = $007CInt$007C_$007C(matchValue);
        if (activePatternResult != null) {
            const accountNo = activePatternResult | 0;
            props.SaveFn(new FeeGeneratedUpdateDTO(generatorState[0], feeIdState[0], invoiceeNrState[0], contractNrState[0], parametersState[0], startDateState[0], endDateState[0], accountNo, props.DTO.Parameters));
        }
        else {
            errorMessageState[1]("Tried to save, but unable to due to data in form not parsing correctly.");
        }
        props.CloseModalFn();
    });
}, "FeeWholesaleModal", uncurry(2, void 0), void 0, "renderFeeWholesaleModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\WholesaleRGU\\View.fs", 730);

class FeeWholesaleSectionProps extends Record {
    constructor(ClientNr, InvoiceeNr, Locale) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.InvoiceeNr = InvoiceeNr;
        this.Locale = Locale;
    }
}

function FeeWholesaleSectionProps$reflection() {
    return record_type("Containers.WholesaleRGU.View.FeeWholesaleSectionProps", [], FeeWholesaleSectionProps, () => [["ClientNr", int32_type], ["InvoiceeNr", class_type("System.Int64")], ["Locale", Locale$reflection()]]);
}

const renderFeeWholesaleSection = FunctionComponent_Of_Z5A158BBF((props) => {
    let fees, inputRecord, children_11;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const feeGeneratedLoadState = react.useState(new LoadState$2(0));
    const editModalState = react.useState(void 0);
    const errorMessageState = react.useState(void 0);
    const showEndedState = react.useState(false);
    const loadFeeWholesale = () => {
        loadEffect(() => FeeWholesale_read(props.ClientNr, props.InvoiceeNr), (arg) => {
            feeGeneratedLoadState[1](arg);
        });
    };
    react.useEffect(loadFeeWholesale, [props.ClientNr, props.InvoiceeNr]);
    const saveFeeWholesale = (isUpdate, generator, dto) => {
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(isUpdate ? FeeWholesale_update(props.ClientNr, props.InvoiceeNr, dto) : FeeWholesale_create(props.ClientNr, props.InvoiceeNr, dto), (_arg) => {
            const result = _arg;
            return singleton_1.Combine((result.tag === 1) ? ((errorMessageState[1](result.fields[0]), singleton_1.Zero())) : ((singleton_1.Zero())), singleton_1.Delay(() => {
                loadFeeWholesale();
                return singleton_1.Zero();
            }));
        })));
    };
    let editModalHtml;
    const matchValue = editModalState[0];
    editModalHtml = ((matchValue != null) ? renderFeeWholesaleModal(matchValue) : react.createElement(react.Fragment, {}));
    const matchValue_1 = feeGeneratedLoadState[0];
    switch (matchValue_1.tag) {
        case 1: {
            return dotsLoading;
        }
        case 3: {
            return error(matchValue_1.fields[0].split(""));
        }
        case 2: {
            const feeWholesales = matchValue_1.fields[0];
            const rows = map((dto_1) => {
                let format_1;
                const renderCell = toString;
                return [ofArray([renderCell(dto_1.Generator), int32ToString(dto_1.FeeId), defaultArg(map_1(int32ToString, dto_1.InvoiceeNr), ""), defaultArg(map_1(int32ToString, dto_1.ContractNr), ""), dto_1.Parameters, DateModule_toStr(DateFormat_get_yyyy$002DMM$002Ddd(), dto_1.StartDate), defaultArg(map_1((format_1 = DateFormat_get_yyyy$002DMM$002Ddd(), (d_1) => DateModule_toStr(format_1, d_1)), dto_1.EndDate), ""), renderCell(dto_1.AccountNo)]), toText(printf("%s-%i"))(dto_1.Generator)(dto_1.FeeId)];
            }, (fees = feeWholesales, (!(showEndedState[0])) ? filter((f) => {
                if (f.EndDate == null) {
                    return true;
                }
                else {
                    return compare(f.EndDate, DateModule_today()) > 0;
                }
            }, fees) : fees));
            const dotMenu = singleton_2([getTranslation("Common.Edit"), (rowId_1) => {
                let patternInput;
                const splitted = split(rowId_1, ["-"], null, 0);
                patternInput = [splitted[0], parseInt$(splitted[1])];
                const _arg_1 = patternInput[1];
                if (_arg_1 == null) {
                    logei("Cannot find Fee Generator based on RowId: " + rowId_1);
                }
                else {
                    const feeId$0027 = _arg_1 | 0;
                    const _arg_2 = tryFind((feeWholesale) => {
                        if (feeWholesale.Generator === patternInput[0]) {
                            return feeWholesale.FeeId === feeId$0027;
                        }
                        else {
                            return false;
                        }
                    }, feeWholesales);
                    if (_arg_2 == null) {
                        logei("Cannot find Fee Generator based on RowId: " + rowId_1);
                    }
                    else {
                        ((ctp) => {
                            const modalProps_1 = new FeeWholesaleModalProps(ctp, (dto_2) => {
                                saveFeeWholesale(true, ctp.Generator, dto_2);
                            }, () => {
                                editModalState[1](void 0);
                            }, props.Locale);
                            editModalState[1](modalProps_1);
                        })(_arg_2);
                    }
                }
            }]);
            let errorMessageHtml;
            const matchValue_2 = errorMessageState[0];
            if (matchValue_2 != null) {
                const msg_2 = matchValue_2;
                errorMessageHtml = error(msg_2.split(""));
            }
            else {
                errorMessageHtml = react.createElement(react.Fragment, {});
            }
            let showEndedSwitchHtml;
            const children_5 = [react.createElement("span", {}, "Visa även avslutade"), render_3((inputRecord = SwitchProps_get_GetDefault(), new SwitchProps("show-ended-switch", showEndedState[0], (e) => {
                const arg_6 = Browser_Types_Event__Event_get_Checked(e);
                showEndedState[1](arg_6);
            }, inputRecord.IsDisabled)))];
            showEndedSwitchHtml = react.createElement("div", {
                className: "simple-container--horizontal",
            }, ...children_5);
            const createContractTypePriceRguStratumButtonHtml = wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("Common.CreateNew"), defaultProps.Content, (_arg_3) => {
                const arg_8 = new FeeWholesaleModalProps(new FeeGeneratedDTO("", 0, void 0, void 0, "", fromDateTime(now()), void 0, 0), (dto_4) => {
                    saveFeeWholesale(false, dto_4.Generator, dto_4);
                }, () => {
                    editModalState[1](void 0);
                }, props.Locale);
                editModalState[1](arg_8);
            }, defaultProps.Disabled, "create-contract-type-price-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon));
            const children_13 = [react.createElement("h3", {}, "FeeWholesale"), errorMessageHtml, react.createElement("div", {
                className: "simple-container--horizontal",
            }, createContractTypePriceRguStratumButtonHtml, showEndedSwitchHtml), (children_11 = [renderDotMenuAreaTable(ofArray(["Generator", "FeeId", "InvoiceeNr", "ContractNr", "Parameters", "StartDate", "EndDate", "AccountNo"]), rows, (_arg_4) => dotMenu, void 0, void 0, (value_3) => {
            })], react.createElement("div", {
                className: "fit-content",
            }, ...children_11)), editModalHtml];
            return react.createElement("div", {
                id: "fee-wholesale",
                className: "simple-container",
            }, ...children_13);
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}, "FeeWholesaleSection", uncurry(2, void 0), void 0, "renderFeeWholesaleSection", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\WholesaleRGU\\View.fs", 915);

export class WholesaleRGUProps extends Record {
    constructor(ClientNr, InvoiceeNr, Locale) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.InvoiceeNr = InvoiceeNr;
        this.Locale = Locale;
    }
}

export function WholesaleRGUProps$reflection() {
    return record_type("Containers.WholesaleRGU.View.WholesaleRGUProps", [], WholesaleRGUProps, () => [["ClientNr", int32_type], ["InvoiceeNr", class_type("System.Int64")], ["Locale", Locale$reflection()]]);
}

export const renderWholesaleRGU = FunctionComponent_Of_Z5A158BBF((props) => {
    const props_1 = [new HTMLAttr(99, "wholesale-rgu"), new HTMLAttr(65, stackClasses(ofArray(["wholesale-rgu", "d-flex", "flex-column"])))];
    const children = [renderContractTypePriceSection(new ContractTypePriceSectionProps(props.ClientNr, props.InvoiceeNr)), renderContractTypePriceRguStratumSection(new ContractTypePriceRguStratumSectionProps(props.ClientNr, props.InvoiceeNr)), renderFeeWholesaleSection(new FeeWholesaleSectionProps(props.ClientNr, props.InvoiceeNr, props.Locale))];
    return react.createElement("div", keyValueList(props_1, 1), ...children);
}, "WholesaleRGU", uncurry(2, void 0), void 0, "renderWholesaleRGU", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\WholesaleRGU\\View.fs", 933);

